import defaultAxios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import * as uuid from "uuid";

const httpService: AxiosInstance = defaultAxios.create({
  baseURL: "/redx/platform/",
  headers: {
    "Accept-Language": "en",
    "X-Target-System": "DIMENSIONS_UBS",
  },
});

httpService.interceptors.request.use((config: AxiosRequestConfig) => {
  config.headers["X-Request-Id"] = uuid.v4();
  return config;
});

// initialize request interceptor
httpService.interceptors.request.use(
  (config: AxiosRequestConfig) => config,
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

httpService.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError) => {
    const config = error.config;
    const headers = config.headers;
    const requestId = headers["X-Request-Id"];

    return Promise.reject({ ...error, request: { ...error.request, requestId: requestId } });
  }
);

export { httpService };
